import * as ReactDOM from 'react-dom/client';

import { App } from './app/App';
import { sentryService } from './app/application/SentryService';

// if (process.env.NODE_ENV === `development`) {
//   // eslint-disable-next-line @typescript-eslint/no-var-requires
//   const whyDidYouRender = require(`@welldone-software/why-did-you-render`);
//   whyDidYouRender(React, {
//     // trackAllPureComponents: true, // Habilita para todos los componentes puros
//     logOwnerReasons: true, // Opción para logs más detallados
//   });
// }

sentryService.init();

const root = ReactDOM.createRoot(document.getElementById(`root`) as HTMLElement);

root.render(
  /**
   * This is not working due to a fail in the google-map-react library.
   * See: https://github.com/google-map-react/google-map-react/issues/1116
   *
   */
  // <StrictMode>
  <App />
  // </StrictMode>
);
